
(function($) {

  // Used to toggle mobile menu
  $('.nav-trigger').on('click', function() {
    $('body').toggleClass('js-menu-active');
  });

  // Iniate slider on home
  $(".home-slider").slick({
    dots: true,
    speed: 750,
    autoplay: true,
    autoplaySpeed: 3000,
    infinite: true,
    fade: true,
    cssEase: 'linear',
    pauseOnHover: false,
    arrows: false,
    accessibility: false,
    customPaging: function(slider, i) {
        return '<a href="#" data-role="none" aria-required="false" tabindex="0"></a>';
    },
  });

  // init Masonry
  var $grid = $('.gallery-grid').masonry({
    itemSelector: '.gallery-item',
//    isFitWidth: true,
    percentPosition: true,
  });
  // layout Masonry after each image loads
  $grid.imagesLoaded().progress( function() {
    $grid.masonry('layout');
  });

  $( window ).resize(function() {
    $grid.masonry('layout');
  });

})(jQuery); // Fully reference jQuery after this point.
